/*
  © 2024 KondaSoft
  https://www.kondasoft.com
*/

class KsProductInventory extends HTMLElement {
  constructor () {
    super()

    document.querySelector('product-info').addEventListener('product-info:loaded', () => {
      // console.log(event)
      this.initProgressBar()
    })

    document.querySelector('product-info').addEventListener('change', () => {
      // console.log(event)
      this.initProgressBar()
    })
  }

  initProgressBar () {
    setTimeout(() => {
      const progressBar = this.querySelector('.bs-progress-bar')
      progressBar.style.width = progressBar.dataset.width
    }, 500)
  }
}
customElements.define('ks-product-inventory', KsProductInventory)


class KsProductQuantityBreaks extends HTMLElement {
  constructor () {
    super()
    
    this.handleInputChange()
  }

  handleInputChange () {
    const productInfo = this.closest('product-info')
    const qtyField = productInfo.querySelector('input[name="quantity"]')
    const submitBtn = productInfo.querySelector('.product-form__buttons button')

    if (!qtyField) {
      productInfo.querySelector('.product-form__buttons').insertAdjacentHTML('beforebegin', `
        <input type="hidden" name="quantity" value="1">  
      `)
    }
    
    this.querySelectorAll('input').forEach(input => {
      input.addEventListener('change', () => {
        productInfo.querySelector('[name="quantity"]').value = input.value

        if (this.dataset.btnAnimate.length) { 
          setTimeout(() => {
            submitBtn.classList.add('animate__animated', this.dataset.btnAnimate)
          }, 250)

          setTimeout(() => {
            submitBtn.classList.remove('animate__animated', this.dataset.btnAnimate)
          }, 1500)
        }
      })
    })
  }
}
customElements.define('ks-product-quantity-breaks', KsProductQuantityBreaks)


class KsStickyATC extends HTMLElement {
  constructor () {
    super()

    this.variantSelector = this.querySelector('select[name="id"]')
    this.mainVariantInput = document.querySelector('.product .product-form input[name="id"]')

    this.init()

    this.variantSelector?.addEventListener('change', (event) => {
      this.onVariantChange(event)
    })
    
    this.mainVariantInput.addEventListener('change', (event) => {
      this.onMainProductFormVariantChange(event)
    })
  }

  init () {
    const top = document.querySelector('.product product-form').getBoundingClientRect().bottom + window.scrollY

    window.addEventListener('scroll', () => {
      if (window.scrollY > top) {
        if (document.querySelector('.product .ks-sticky-atc')) {
          document.body.insertAdjacentElement('beforeend', this)
        }
        this.classList.add('show')
        document.body.style.paddingBottom = this.clientHeight + 'px'
      } else {
        this.classList.remove('show')
        document.body.style.paddingBottom = 0
      }
    })
  }

  onVariantChange (event) {
    event.preventDefault()
    const imgSrc = this.variantSelector.options[this.variantSelector.selectedIndex].dataset.variantImg

    if (imgSrc) {
      const img = this.variantSelector.closest('.ks-sticky-atc').querySelector('.ks-sticky-atc-img')
      img.src = imgSrc
    }
  }

  onMainProductFormVariantChange () {
    this.variantSelector.value = this.mainVariantInput.value
    this.variantSelector.dispatchEvent(new Event('change'))
  }
}
customElements.define('ks-sticky-atc', KsStickyATC)

class KsProductPrevNext extends HTMLElement {
  constructor () {
    super()

    this.injectVendorScripts()

    if (window.matchMedia('(min-width: 750px').matches) {
      document.body.insertAdjacentElement('beforeend', this)
    } 

    this.querySelectorAll('.ks-product-block-prev-next-inner').forEach((elem) => {
      this.handleTooltip(elem)
    })
  }

  async injectVendorScripts () {
    if (!window.FloatingUICore) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.8')
      document.head.appendChild(script) 
    }
    if (!window.FloatingUIDOM) {
      await new Promise(r => setTimeout(r, 500))

      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.8')
      document.head.appendChild(script)
    }
  }

  handleTooltip(elem) {
    const btn = elem.querySelector('a')
    const tooltip = elem.querySelector('.ks-tooltip')

    if (!btn) return

    async function update() {
      window.FloatingUIDOM.computePosition(btn, tooltip, {
        middleware: [
          window.FloatingUIDOM.offset(10),
          window.FloatingUIDOM.autoPlacement()
        ],
      }).then(({x, y}) => {
        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        })
      })
    }

    async function showTooltip() {
      await new Promise(resolve => setTimeout(resolve, 200))

      tooltip.classList.add('show')
      update()
    }
    
    function hideTooltip() {
      setTimeout(() => {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200)
      }, 100)
    }
    
    [
      ['mouseenter', showTooltip],
      ['mouseleave', hideTooltip],
      ['focus', showTooltip],
      ['blur', hideTooltip],
    ].forEach(([event, listener]) => {
      btn.addEventListener(event, listener)
    })

  }
}
customElements.define('ks-product-prev-next', KsProductPrevNext)

class KsPersonalizationField extends HTMLElement {
  constructor () {
    super()

    this.form = this.closest('.product').querySelector('product-form form')
    this.atcBtn = this.form.querySelector('button[name="add"]')
    this.buyBtn = this.form.querySelector('shopify-buy-it-now-button button')

    switch (this.dataset.type) {
      case 'text':
      case 'email':
      case 'tel':
      case 'textarea':
      case 'date':
        this.handleInput()
        break;
      case 'select':
        this.handleSelect()
        break;
      case 'checkbox':
        this.handleCheckboxes()
        break;
      case 'radio':
        this.handleRadios()
        break;
      case 'file':
        break;
    }
  }

  handleInput () {
    const input = this.querySelector('.field__input')
    
    this.form.insertAdjacentHTML('beforeend', `
      <input type="hidden" name="${input.getAttribute('name')}" value="${input.value}" required>
    `)

    input.addEventListener('input', () => {
      this.form.querySelector(`[name="${input.getAttribute('name')}"]`).value = input.value
    })
  }

  handleSelect () {
    const select = this.querySelector('select')
    
    this.form.insertAdjacentHTML('beforeend', `
      <input type="hidden" name="${select.getAttribute('name')}" value="${select.value}" required>
    `)

    select.addEventListener('change', () => {
      this.form.querySelector(`[name="${select.getAttribute('name')}"]`).value = select.value
    })
  }

  handleCheckboxes () {
    const name = this.querySelector('[type="checkbox"]').getAttribute('name')

    this.form.insertAdjacentHTML('beforeend', `
      <input type="hidden" name="${name}" value="" required>
    `)

    const setHidden = () => {
      const inputHidden = this.form.querySelector(`[name="${name}"]`)

      const checkedValues = [...this.querySelectorAll('input[type="checkbox"]:checked')].map((checkbox, index) => {
        if (index > 0) {
          return ' ' + checkbox.value
        } else {
          return checkbox.value
        }
      })
      inputHidden.value = checkedValues
    }
    setHidden()

    this.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        setHidden()
      })
    })
  }

  handleRadios () {
    const name = this.querySelector('[type="radio"]').getAttribute('name')

    this.form.insertAdjacentHTML('beforeend', `
      <input type="hidden" name="${name}" value="" required>
    `)

    const setHidden = () => {
      this.form.querySelector(`[name="${name}"]`).value = this.querySelector('[type="radio"]:checked').value
    }
    setHidden()

    this.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', () => {
        setHidden()
      })
    })
  }
}
customElements.define('ks-personalization-field', KsPersonalizationField)

class KsPersonalizationFieldFileUpload extends HTMLElement {
  constructor () {
    super()

    this.loadStyleScripts()

    const vendorScript = document.querySelector('script[src*="plugin-image-preview"]')
    vendorScript.onload = () => {
      this.init()
    }

    window.addEventListener('ks.product.quick_view.modal_shown', () => this.init())
  }

  loadStyleScripts () {
    if (document.querySelector('script[src*="plugin-image-preview"]')) return

    const style1 = document.createElement('link')
    style1.setAttribute('href', 'https://cdn.jsdelivr.net/npm/filepond@4.31.1/dist/filepond.min.css')
    style1.setAttribute('rel', 'stylesheet')
    style1.setAttribute('integrity', 'sha256-a95jYCBL4++k1XyLYgulKmY33bIJIVYMsJO/RNytaJM=')
    style1.setAttribute('crossorigin', 'anonymous')
    document.head.appendChild(style1)

    const style2 = document.createElement('link')
    style2.setAttribute('href', 'https://cdn.jsdelivr.net/npm/filepond-plugin-image-preview@4.6.12/dist/filepond-plugin-image-preview.min.css')
    style2.setAttribute('rel', 'stylesheet')
    style2.setAttribute('integrity', 'sha256-YsO8aMI20vSizdmc2mmWx2DU1wof4v60Nwy7hIBvdM8=')
    style2.setAttribute('crossorigin', 'anonymous')
    document.head.appendChild(style2)

    const script1 = document.createElement('script')
    script1.setAttribute('src', 'https://cdn.jsdelivr.net/npm/filepond@4.31.1/dist/filepond.min.js')
    script1.setAttribute('integrity', 'sha256-6yXpr8+sATA4Q2ANTyZmpn4ZGP7grbIRNpe9s0Y+iO0=')
    script1.setAttribute('crossorigin', 'anonymous')
    script1.setAttribute('defer', 'defer')
    document.head.appendChild(script1)

    const script2 = document.createElement('script')
    script2.setAttribute('src', 'https://cdn.jsdelivr.net/npm/filepond-plugin-image-preview@4.6.12/dist/filepond-plugin-image-preview.min.js')
    script2.setAttribute('integrity', 'sha256-1vQHytMrpOsKFyUUPuEVhxeNH6UhMX3uNetDRvlSpwU=')
    script2.setAttribute('crossorigin', 'anonymous')
    script1.setAttribute('defer', 'defer')
    document.head.appendChild(script2)
  }

  async init () {
    await new Promise(resolve => setTimeout(resolve, 200))

    window.FilePond.registerPlugin(window.FilePondPluginImagePreview)

    const inputElem = this.querySelector('input[type="file"]')

    const pond = window.FilePond.create(inputElem, {
      storeAsFile: true,
      labelIdle: this.querySelector('[data-label-text]').innerHTML
    })

    pond.on('addfile', () => {
      setTimeout(() => {
        this.closest('.product').querySelector('.product-form form')
          .insertAdjacentElement('beforeend', this.querySelector('.filepond--data'))
      }, 1000)
    })
  }
}
customElements.define('ks-personalization-field-file-upload', KsPersonalizationFieldFileUpload)

// Shopify subscriptions app smal fix
document.querySelectorAll('.shopify_subscriptions_app_block [type="radio"]').forEach(radio => {
  radio.classList.add('bs-form-check-input')
});

/*
  Product specifications / attributes / price breakup
*/
(function () {
  const productSpecs = document.querySelector('.product-specs')
  if (!productSpecs) return

  const variantSelector = document.querySelector('product-info .product-form [name="id"]')
  if (!variantSelector) return

  variantSelector.addEventListener('change', async () => {
    console.log(window.location.href);
    const respoonse = await fetch(window.location.href);
    const text = await respoonse.text();
    const newDoc = new DOMParser().parseFromString(text, "text/html");
    
    productSpecs.innerHTML = newDoc.querySelector('.product-specs').innerHTML

    const priceBreakup = document.querySelector('.product-price-breakup')
    if (priceBreakup) {
      priceBreakup.innerHTML = newDoc.querySelector('.product-price-breakup').innerHTML
    }
  })
})()